import React, { Component, createRef } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import common from '~/common';
import { logError } from '~/common/utils';
import Actions from '~/Actions';
import Actions_Wind_V2 from '~/Actions_Wind_V2';

import Page_Home from '~/containers/Page_Main/Page_Home';
import TreeList from '~/containers/Page_Main/TreeList';
import DataList from '~/containers/Page_Main/TreeList/DataList';
import PageLabel from '~/containers/Page_Main/PageLabel';
import NotifyDialog from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo/NotifyDialog';

import '~/font.css';
import CheckActDialog from './CheckActDialog';
import CheckLogoutDialog from './CheckLogoutDialog';
import CheckTime from '~/components/Dialog/CheckTime';
import TitleBar from './TitleBar';
import { exportComponentAsJPEG } from 'react-component-export-image';

class App extends Component {
  constructor(props) {
    super(props);
    this.componentRef = createRef();
  }
  state = { 
    treeList_hide: false, 
    checkLogout: false, 
    contentOpacity: 0,
    openNotify: false,
    notificationCounts: {
      admin_program_size: 0,
      work_progress_size: 0
    }
  }

  componentDidMount () {
    const { getAtyFunction } = this.props;
    getAtyFunction();

    this.deadLine = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
    window.addEventListener('mousemove', this.handleMouseMove);
    this.logoutTimer = setInterval(() => {
      const { check = {} } = this.props;
      const { token_exp = '' } = check;
      let check_deadline = token_exp.replace(' ', 'T');
      while (check_deadline.match('/')) {
        check_deadline = check_deadline.replace('/', '-');
      }
      if (new Date() > this.deadLine || (token_exp.length > 0 && new Date() > new Date(check_deadline))) { this.logout(); }
    }, 1000);

    this.fadeIn();
    this.fetchNotificationCounts();
  }

  fetchNotificationCounts = async () => {
    try {
      const [adminPrograms, workProgress] = await Promise.all([
        Actions_Wind_V2.getAllUnapprovalAdminPrograms(),
        Actions_Wind_V2.getAllUnapprovalWorkProgress()
      ]);

      this.setState({
        notificationCounts: {
          admin_program_size: adminPrograms?.length || 0,
          work_progress_size: workProgress?.length || 0
        },
        openNotify: true
      });
    } catch (error) {
      logError(error, 'fetchNotificationCounts');
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    window.removeEventListener('mousemove', this.handleMouseMove);
    clearInterval(this.logoutTimer);
    clearKey('AtyFunction');
    clearKey('PathAry');
  }

  componentDidUpdate (preProps) {
    const { history } = this.props;
    if (history.location.pathname !== this.path) {
      this.path = history.location.pathname;
      this.setState({ contentOpacity: 0 });
      this.fadeIn();
    }
  }

  _clickTreeBtn=() => this.setState({ treeList_hide: !this.state.treeList_hide })

  logout=() => {
    const { getLogout, clearSession, clearJwtKey, history } = this.props;
    getLogout();
    clearSession();
    clearJwtKey('Check');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    history.push(`${common.rootPath}/Manage/Login`);
  }

  handleMouseMove = e => { this.deadLine = new Date(new Date().setMinutes(new Date().getMinutes() + 30)); }

  fadeIn=() => {
    const timer = setInterval(() => {
      this.setState({ contentOpacity: 1 });
      clearInterval(timer);
    }, 10);
  }

  handleCloseNotify = () => {
    this.setState({ openNotify: false });
  }

  render () {
    const { treeList_hide, checkLogout, contentOpacity, openNotify, notificationCounts } = this.state;
    const { pathAry = [] } = this.props;
    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
        <TitleBar onLogout={() => this.setState({ checkLogout: true })} onClickTreeBtn={this._clickTreeBtn} />
        <div id="view_main" style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          <TreeList hide={treeList_hide} />
          <div id="content_main" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <PageLabel />
            <div id="content_main_inner" ref={this.componentRef} style={{ flex: 1, position: 'relative', opacity: contentOpacity, transition: contentOpacity > 0 ? 'opacity ' : 'none' }}>
              <Route exact path={`${common.rootPath}/Manage/Main`} component={Page_Home} />
              {DataList.map((o1, i1) => o1.detail.map((o2, i2) => {
                if (o2.detail.length > 0) {
                  return o2.detail.map((o3, i3) => {
                    if (pathAry.indexOf(o3.path) > -1) {
                      return <Route key={`/Main/${o1.path}/${o2.path}/${o3.path}`} exact path={`${common.rootPath}/Manage/Main/${o1.path}/${o2.path}/${o3.path}`} component={o3.page} />;
                    }
                    return null;
                  });
                } else if (o2.page && pathAry.indexOf(o2.path) > -1) {
                  return <Route key={`/Main/${o1.path}/${o2.path}`} exact path={`${common.rootPath}/Manage/Main/${o1.path}/${o2.path}`} component={o2.page} />;
                }
                return null;
              }))}
            </div>
            <div style={{ marginBottom: 22.8, fontSize: 16, lineHeight: '23.17px', color: '#186279' }}>{`  ${common.backTitle} All rights reserved.`}</div>
          </div>
        </div>
        <CheckActDialog />
        <CheckLogoutDialog open={checkLogout} onCheck={this.logout} onCancel={() => this.setState({ checkLogout: false })} />
        <CheckTime />
        <NotifyDialog 
          open={openNotify}
          onClose={this.handleCloseNotify}
          notificationCounts={notificationCounts}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  check: state.JWT.Check,
  pathAry: state.data.PathAry,
});

const mapDispatchToProps = dispatch => ({
  getLogout: () => Actions.getLogout(dispatch),
  clearSession: () => dispatch(Actions.clearSession()),
  getAtyFunction: () => Actions.getAtyFunction(dispatch),
  clearJwtKey: key => Actions.clearJwtKey(dispatch, { key }),
  clearKey: key => Actions.clearKey(dispatch, { key }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
